import * as THREE from 'three';
import { SCALE_FACTOR, SCALE } from './constants';

export function buildPnoMatrixSegmentation(ele: number[], height: number, width: number) {
  const scaleFactor = SCALE_FACTOR;
  const scale = SCALE;

  // Raw PNO (Abbott style 4×4 with column-major layout)
  const pnoMatrix = new THREE.Matrix4();
  pnoMatrix.set(
    ele[0],
    ele[4],
    ele[8],
    ele[12] * scale * scaleFactor,
    ele[1],
    ele[5],
    ele[9],
    ele[13] * scale * scaleFactor,
    ele[2],
    ele[6],
    ele[10],
    ele[14] * scale * scaleFactor,
    ele[3],
    ele[7],
    ele[11],
    ele[15]
  );

  // orientation corrections
  let m = new THREE.Matrix4().makeTranslation(-(width * scale) / 2, 0, 0);
  m = new THREE.Matrix4().multiplyMatrices(new THREE.Matrix4().makeRotationZ(Math.PI / 2), m);
  m = new THREE.Matrix4().multiplyMatrices(new THREE.Matrix4().makeRotationY(Math.PI / 2), m);
  m = new THREE.Matrix4().multiplyMatrices(pnoMatrix, m);
  return m;
}

export function buildPnoMatrixFan(ele: number[], height: number, width: number) {
  const scaleFactor = SCALE_FACTOR;
  const scale = SCALE;

  // Raw PNO (Abbott style 4×4 with column-major layout)
  const pnoMatrix = new THREE.Matrix4();
  pnoMatrix.set(
    ele[0],
    ele[4],
    ele[8],
    ele[12] * scale * scaleFactor,
    ele[1],
    ele[5],
    ele[9],
    ele[13] * scale * scaleFactor,
    ele[2],
    ele[6],
    ele[10],
    ele[14] * scale * scaleFactor,
    ele[3],
    ele[7],
    ele[11],
    ele[15]
  );

  // orientation corrections
  let m = new THREE.Matrix4().makeScale(
    scale * scaleFactor,
    scale * scaleFactor,
    scale * scaleFactor
  );
  m = new THREE.Matrix4().multiplyMatrices(new THREE.Matrix4().makeRotationY(Math.PI / 2), m);
  m = new THREE.Matrix4().multiplyMatrices(new THREE.Matrix4().makeRotationX(-Math.PI / 2), m);
  m = new THREE.Matrix4().multiplyMatrices(pnoMatrix, m);
  return m;
}
